/* eslint-disable react/no-array-index-key */
/* eslint-disable no-plusplus */
import React, { Component } from 'react';

import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import {
  Box,
  Button,
  Container,
  Grid,
  Typography,
  Paper,
  ButtonBase,
  Chip,
  IconButton,
  Stack,
  Divider,
} from '@mui/material';
import MobileStepper from '@mui/material/MobileStepper';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import ReactPlaceholder from 'react-placeholder/lib';
import { connect } from 'react-redux';
import SwipeableViews from 'react-swipeable-views';
import { Breadcrumbs } from 'wae_rwlb_reactlibrary';

import { getItemData, resetItemData, addToCart } from '../../../actions/index';
import './styles.css';
import { COLOR } from '../../../helpers/colors';
import { breadcrumbNameMap } from '../../../helpers/config';
import { formatAmount } from '../../../helpers/functions';
import ProductDetailsPlaceholder from '../ProductDetailsPlaceholder';
import { iconStyle, Img } from './styles';

const imageBaseURL = '/no-image-available.png';

class ProductDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      images: [],
      image: '',
      activeStep: 0,
    };
  }

  async componentDidMount() {
    try {
      this.props.resetItemData();
      const { match } = this.props;
      const { params } = match;
      const { itemId } = params;
      const images = [];
      images.push({ imgPath: `${imageBaseURL}` });
      for (let i = 1; i < 5; i++) {
        images.push({ imgPath: `${imageBaseURL}` });
      }
      this.setState({ images });

      await this.props.getItemData(itemId);
    } catch (err) {
      console.log(err);
    }
  }

  handleAddToCartClick = () => {
    try {
      const { t, product } = this.props;

      const { selItemData } = product;
      const {
        Material,
        MaterialName,
        MaterialGrossWeight,
        ConditionQuantity,
        SalesPrice,
        SalesPriceUnit,
        StockQuantityUOM,
        StockQuantity,
      } = selItemData;
      this.props.addToCart({
        Material,
        qty: parseInt(ConditionQuantity, 10),
        MaterialName,
        Price: SalesPrice,
        Currency: SalesPriceUnit,
        ConditionQuantity,
        MaterialGrossWeight,
        available: true,
        StockQuantityUOM,
        StockQuantity,
      });
      this.props.enqueueSnackbar(t('productScreenTranslations:SUCC_ADDED_TO_THE_CART'), {
        variant: 'success',
      });
    } catch (err) {
      const { t } = this.props;

      this.props.enqueueSnackbar(t('productScreenTranslations:SOMETHING_WENT_WRONG'), {
        variant: 'error',
      });
      console.log(err);
    }
  };

  handleNext = () => {
    try {
      const { activeStep, images } = this.state;

      this.setState({
        image: images[activeStep + 1],
        activeStep: activeStep + 1,
      });
    } catch (err) {
      console.log(err);
    }
  };

  handleBack = () => {
    try {
      const { activeStep, images } = this.state;
      this.setState({
        image: images[activeStep - 1],
        activeStep: activeStep - 1,
      });
    } catch (err) {
      console.log(err);
    }
  };

  handleStepChange = step => {
    try {
      const { images } = this.state;
      this.setState({ image: images[step], activeStep: step });
    } catch (err) {
      console.log(err);
    }
  };

  onClickGoBackToProducts = () => {
    this.props.history.push('/products');
  };

  returnPriceQuantity = () => {
    try {
      const { selItemData } = this.props.product;
      return (
        selItemData || {
          ConditionRateValueUnit: undefined,
          ConditionRateValue: undefined,
          ConditionQuantity: '1',
          ConditionQuantityUnit: 'EA',
          MaterialGrossWeight: '1',
          MaterialWeightUnit: 'KG',
        }
      );
    } catch (err) {
      console.log(err);
      return {
        ConditionRateValueUnit: undefined,
        ConditionRateValue: undefined,
        ConditionQuantity: '1',
        ConditionQuantityUnit: 'EA',
        MaterialGrossWeight: '1',
        MaterialWeightUnit: 'KG',
      };
    }
  };

  renderImageSlider = () => {
    const { image, activeStep, images } = this.state;
    const { i18n, t } = this.props;
    const maxSteps = images.length;
    return (
      <Grid item xs={12}>
        <Grid item xs={12} textAlign="center">
          <SwipeableViews
            axis={i18n.dir() === 'rtl' ? 'x-reverse' : 'x'}
            index={activeStep}
            onChangeIndex={this.handleStepChange}
            enableMouseEvents
          >
            {images.map((step, index) => (
              <div key={index.toString()}>
                <img
                  src={step.imgPath}
                  alt=""
                  loading="lazy"
                  style={{
                    width: '100%',
                    borderRadius: 8,
                    flex: 1,
                  }}
                  onError={e => {
                    e.target.src = imageBaseURL;
                  }}
                />
                <Grid xs={12} item textAlign={i18n.dir() === 'rtl' ? 'start' : 'end'}>
                  <Chip
                    label={`${activeStep + 1} ${t('productScreenTranslations:OF')} ${
                      images.length
                    } ${t('productScreenTranslations:PHOTOS')}`}
                    sx={{
                      background: COLOR.lightBlackColor,
                      color: COLOR.whiteTextColor,
                      paddingY: 0.75,
                      paddingX: 0.5,
                      height: { xs: 16, sm: 16, md: 24 },
                      marginTop: { xs: '-30%', sm: '-20%', md: '-12%' },
                      marginRight: '3%',
                      fontSize: { xs: 6, sm: 8, md: 12 },
                    }}
                  />
                </Grid>
              </div>
            ))}
          </SwipeableViews>
          <MobileStepper
            className="custom-stepper"
            steps={0}
            position="static"
            activeStep={activeStep}
            nextButton={
              <IconButton
                size="small"
                onClick={this.handleNext}
                disabled={activeStep === maxSteps - 1}
              >
                {i18n.dir() === 'rtl' ? (
                  <KeyboardArrowLeft sx={iconStyle} />
                ) : (
                  <KeyboardArrowRight sx={iconStyle} />
                )}
              </IconButton>
            }
            backButton={
              <IconButton size="small" onClick={this.handleBack} disabled={activeStep === 0}>
                {i18n.dir() === 'rtl' ? (
                  <KeyboardArrowRight sx={iconStyle} />
                ) : (
                  <KeyboardArrowLeft sx={iconStyle} />
                )}
              </IconButton>
            }
          />
        </Grid>

        <Stack direction="row" spacing={3} sx={{ p: 1 }} className="horizontal-scroll">
          {images.map((m, i) => (
            <ButtonBase
              key={m.imgPath}
              sx={{
                height: 75,
                width: 100,
                flex: '0 0 auto',
                transition: 'all 0.2s ease 0s',
                border: image === m ? '2px solid red' : '1px solid transparent',
                cursor: 'pointer',
                '&:hover': {
                  boxShadow: ' 0px 5px 15px rgba(0, 0, 0, 0.3)',
                  border: '2px solid red',
                },
              }}
              onClick={() => this.setState({ image: m, activeStep: i })}
            >
              <Img
                alt="complex"
                src={m.imgPath}
                onError={e => {
                  e.target.src = imageBaseURL;
                }}
              />
            </ButtonBase>
          ))}
        </Stack>
      </Grid>
    );
  };

  renderProductDetails = () => {
    const { product, t, i18n } = this.props;
    const { selItemData } = product;
    const priceDetails = this.returnPriceQuantity();
    const typoColor1 = 'rgb(98, 100, 101)';
    const typoColor2 = 'rgb(43, 45, 46)';
    const dir = i18n.dir();
    const isStockAndPriceAvailable =
      // eslint-disable-next-line eqeqeq
      selItemData.SalesPrice == 0 ||
      selItemData.StockQuantity === 0 ||
      selItemData.StockQuantity === undefined;
    return (
      <Stack>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent={{ xs: 'center', md: 'space-between' }}
          sx={{ marginBottom: 2 }}
          spacing={{ xs: 2, md: 0 }}
        >
          <Stack>
            <Typography
              variant="h6"
              sx={{
                fontSize: { xs: 16, sm: 16, md: 28 },
                fontWeight: 700,
              }}
            >
              {selItemData ? selItemData.MaterialName : null}
            </Typography>
            <Typography
              variant="h6"
              sx={{
                fontSize: { xs: 10, sm: 10, md: 13 },
                color: typoColor1,
              }}
            >
              {t('productScreenTranslations:DESC')}
            </Typography>
          </Stack>
          <Stack>
            <Typography
              sx={{
                fontWeight: 'bold',
                color: 'rgb(224, 0, 0)',
                fontSize: { xs: 10, sm: 16, md: 28 },
              }}
            >
              {formatAmount('en-AE', priceDetails.SalesPrice, priceDetails.SalesPriceUnit)}
            </Typography>
          </Stack>
        </Stack>
        <Divider />
        <Grid container item direction="row" justifyContent="space-between">
          <Grid item xs={12} sm={9} md={9} sx={{ mt: 2 }}>
            {this.renderImageSlider()}
          </Grid>
          <Grid
            item
            xs={12}
            sm={3}
            md={3}
            sx={{ mt: 1, pl: dir === 'rtl' ? 0 : 1, pb: 1, pt: 1, pr: dir === 'rtl' ? 1 : 0 }}
          >
            <Paper
              sx={{
                background: 'rgb(255, 255, 255)',
                borderRadius: 0.75,
                border: '1px solid rgb(238, 240, 241)',
                marginBottom: 2,
                padding: 1.5,
                boxShadow: 'rgb(0 0 0 / 3%) 0px 4px 16px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between ',
              }}
            >
              <Grid container item direction="row" justifyContent="space-between" sx={{ mb: 2 }}>
                <Grid item>
                  <Stack direction="row">
                    <Typography
                      sx={{
                        fontSize: { xs: 10, sm: 10, md: 14 },
                        fontWeight: 400,
                        color: typoColor1,
                      }}
                    >
                      {t('productScreenTranslations:MATERIAL_NUMBER')}: &nbsp;
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: { xs: 10, sm: 10, md: 14 },
                        fontWeight: 600,
                        color: typoColor2,
                      }}
                    >
                      {selItemData ? selItemData.Material : null}
                    </Typography>
                  </Stack>
                  <Stack direction="row">
                    <Typography
                      sx={{
                        fontSize: { xs: 10, sm: 10, md: 14 },
                        fontWeight: 400,
                        color: typoColor1,
                      }}
                    >
                      {t('productScreenTranslations:STOCK_QUANTITY')}: &nbsp;
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: { xs: 10, sm: 10, md: 14 },
                        fontWeight: 600,
                        color: typoColor2,
                      }}
                    >
                      {selItemData !== null
                        ? `${selItemData.StockQuantity} ${selItemData.StockQuantityUOM}`
                        : null}
                    </Typography>
                  </Stack>
                  <Stack direction="row">
                    <Typography
                      sx={{
                        fontSize: { xs: 10, sm: 10, md: 14 },
                        fontWeight: 400,
                        color: typoColor1,
                      }}
                    >
                      {t('productScreenTranslations:GROSS_WEIGHT')}: &nbsp;
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: { xs: 10, sm: 10, md: 14 },
                        fontWeight: 600,
                        color: typoColor2,
                      }}
                    >
                      {selItemData !== null
                        ? `${selItemData.MaterialGrossWeight} ${selItemData.MaterialWeightUnit} `
                        : null}
                    </Typography>
                  </Stack>
                </Grid>
              </Grid>
              <Button
                variant="contained"
                color="primary"
                onClick={this.handleAddToCartClick}
                sx={{ fontSize: { xs: 10, sm: 12, md: 14 } }}
                disabled={isStockAndPriceAvailable}
              >
                {t('productScreenTranslations:ADD_TO_CART')}
              </Button>
            </Paper>
          </Grid>
        </Grid>
      </Stack>
    );
  };

  render() {
    const { product, match, t } = this.props;
    const { selItemData, isItemLoading } = product;
    const { itemId } = match.params;

    return (
      <Container>
        <Breadcrumbs
          {...this.props}
          data={[
            { name: t('productScreenTranslations:HOME'), path: '/' },
            {
              name: t('productScreenTranslations:PRODUCTS'),
              path: '/products',
            },
            {
              name: selItemData && selItemData !== null ? selItemData.MaterialName : '-',
            },
          ]}
          breadcrumbNameMap={breadcrumbNameMap(t)}
        />
        <ReactPlaceholder
          showLoadingAnimation
          ready={!isItemLoading}
          customPlaceholder={<ProductDetailsPlaceholder />}
        >
          {selItemData && selItemData !== null ? (
            <Box sx={{ marginY: 4, marginX: 1 }}>{this.renderProductDetails()}</Box>
          ) : (
            <Box m={5}>
              <Typography variant="h5" textAlign="center">
                {`${t('productScreenTranslations:UNABLE_TO_LOAD')} "${itemId}"`}
              </Typography>
              <Stack flexDirection="row" justifyContent="center">
                <Button variant="text" onClick={this.onClickGoBackToProducts}>
                  {t('productScreenTranslations:GO_BACK_TO_PRODUCTS')}
                </Button>
              </Stack>
            </Box>
          )}
        </ReactPlaceholder>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    product: state.product,
  };
};
const cProductDetails = connect(mapStateToProps, {
  getItemData,
  resetItemData,
  addToCart,
})(ProductDetails);
const tProductDetails = withTranslation(['productScreenTranslations'])(cProductDetails);
const sProductDetails = withSnackbar(tProductDetails);

export { sProductDetails as ProductDetails };
